import { images } from 'assets'
import colors from './_colors.scss'
import fonts from './_fonts.scss'
import breakpoints from './_breakpoints.scss'

export { images, colors, fonts, breakpoints }
